
        import '/home/builduser/work/97f164ade279074e/santa-editor/packages/wixData/components/collectionsSection/collectionsSection.scss.css.virtualfile';
        module.exports = {"sectionHeader":"_sectionHeader_zwhoj_1"};